import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';

const Impressum: React.FC = () => (
  <Box maxW="2xl" mx="auto" mt={12} p={6}>
    <Heading as="h1" size="lg" mb={4}>Impressum</Heading>
    <Text>BlueCare AG<br/>
    Pflanzschulstrasse 3<br/>
    8400 Winterthur<br/>
    info@bluecare.ch</Text>
    <Box mt={6}>
      <Text fontWeight="bold">Geschäftsführer</Text>
      <Text>Lorenz Fehr, Stefan Sieber</Text>
    </Box>
    <Box mt={6}>
      <Text fontWeight="bold">Inhalte</Text>
      <Text>Vivienne Anliker, Professional Marketing Manager<br/>
      BlueCare AG</Text>
    </Box>
    <Text mt={8} fontSize="sm">Dieses Impressum wurde am 02.06.2025 erstellt.</Text>
  </Box>
);

export default Impressum; 